module.exports = vendorProd_library;


//////////////////
// WEBPACK FOOTER
// external "vendorProd_library"
// module id = 4
// module chunks = 42